import Topbar from './TopBar';
import ControlsBar from './ControlsBar';
import ButtonsBar from './ButtonsBar';
import BottomBar from './BottomBar';

const Portrait = {
  Topbar,
  ControlsBar,
  ButtonsBar,
  BottomBar
};

export default Portrait;
